import { Storybook } from "@tento-ui/ui/storybook";
import { TurnBar } from "./bar";

/** Inline, NOT imported from `icons/*.svg`. The storybook harness bundles a
 * card with bun, which does not hand back `.svg` imports as markup — the
 * string arrives as a path, `LonaIcons.$svg` finds no element in it, and the
 * whole card dies on `null.slot`. The app imports the real icons; an example
 * carries its own so the card can never be broken by the asset pipeline. */
const STROKE = 'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';
const RETRY_ICON =
  `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g ${STROKE}><path d="M13.5 8a5.5 5.5 0 1 1-1.6-3.9"/><path d="M13.5 2v3.2h-3.2"/></g></svg>`;
const LINK_ICON =
  `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g ${STROKE}><path d="M6.6 9.4a2.6 2.6 0 0 0 3.7 0l2.1-2.1a2.6 2.6 0 0 0-3.7-3.7l-.9.9"/><path d="M9.4 6.6a2.6 2.6 0 0 0-3.7 0L3.6 8.7a2.6 2.6 0 0 0 3.7 3.7l.9-.9"/></g></svg>`;
const PENCIL_ICON =
  `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g ${STROKE}><path d="M11.4 2.6a1.6 1.6 0 0 1 2.2 2.2L5.5 12.9l-3 .8.8-3z"/></g></svg>`;

export class TurnBarStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · bar";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Faint until hovered — icon actions, then the details button",
        render: () =>
          TurnBar.makeWith({
            actions: [
              { id: "quote", label: "quote this turn", icon: LINK_ICON },
              { id: "retry", label: "re-run this turn", icon: RETRY_ICON },
            ],
            meta: [
              { key: "lane", value: "opencode" },
              { key: "unit", value: "u-104" },
              { key: "rows", value: "12" },
              { key: "at", value: "10:02:14" },
            ],
          }),
      },
      {
        title: "Metadata only — nothing to act on yet",
        render: () =>
          TurnBar.makeWith({
            meta: [
              { key: "lane", value: "claude" },
              { key: "model", value: "claude-opus-5" },
              { key: "rows", value: "38" },
            ],
          }),
      },
      {
        title: "No metadata — the details button is not rendered at all",
        render: () =>
          TurnBar.makeWith({
            actions: [
              { id: "edit", label: "edit the prompt", icon: PENCIL_ICON },
            ],
          }),
      },
      {
        title: "A long value wraps inside the tooltip, not the row",
        render: () =>
          TurnBar.makeWith({
            actions: [{ id: "retry", label: "re-run this turn", icon: RETRY_ICON }],
            meta: [
              { key: "lane", value: "opencode" },
              {
                key: "cwd",
                value:
                  "/Users/james/workspace/tento/tento-node-registry/tento-spool.node/html/routes",
              },
            ],
          }),
      },
      {
        title: "Under a turn — the bar is the quietest thing on the row",
        render: () => {
          const $wrap = document.createElement("div");
          $wrap.style.width = "100%";
          const $prose = document.createElement("p");
          $prose.style.margin = "0 0 4px";
          $prose.style.fontSize = "14px";
          $prose.style.lineHeight = "1.6";
          $prose.textContent =
            "Both files are byte-identical to how they started, so your current prompt and render policy are untouched.";
          $wrap.append(
            $prose,
            TurnBar.makeWith({
              actions: [
                { id: "retry", label: "re-run this turn", icon: RETRY_ICON },
              ],
              meta: [
                { key: "lane", value: "claude" },
                { key: "unit", value: "u-121" },
                { key: "rows", value: "9" },
              ],
            }),
          );
          return $wrap;
        },
      },
    ];
  }
}
